import React from "react";
import AlgorithmConfig from "./AlgorithmConfig";

const ReelAlgorithm = () => (
  <AlgorithmConfig feedType="reel" heading="REELS ALGORITHM" />
);

export default ReelAlgorithm;
